import { Optional } from 'chaika-common-types';
import { LegalEntityData } from 'chaika-frontend-types/frontend-cms';

import { DateHelper } from '@utils/DateHelper';
import { TimezoneHelper } from '@utils/TimezoneHelper';
import { store } from '@store';

interface Data {
    isShowingAuthor: boolean;
    legalEntity: Optional<LegalEntityData>;
    timeByTz: string;
    doctorId: Optional<string>;
    authorId: Optional<string>;
    device: Optional<string>;
}

export function getEntryExtraData(): Data {
    const { entry, legalEntityBranchList, legalEntityList, organizationList, deviceList } = store;

    const isShowingAuthor = !entry.type.isHideAuthorForEntryType();

    const legalEntityId = legalEntityBranchList.getActualOnDayLegalEntityId(entry.organizationId, entry.creationTime);
    const legalEntity = legalEntityId ? legalEntityList.get(legalEntityId) : undefined;

    const organization = organizationList.get(entry.organizationId);
    const timeByTz = DateHelper.toLocalStringDate(
        TimezoneHelper.toTimeZoneFromLocalTimezone(entry.visitTime ?? entry.creationTime, organization?.tzCode ?? ''),
        true,
    );

    const doctorId = !!entry.doctorId ? entry.doctorId : undefined;
    const authorId = entry.authorId ? entry.authorId : undefined;
    const device = !!entry.deviceId ? deviceList.get(entry.deviceId)?.name : undefined;

    return {
        isShowingAuthor,
        legalEntity,
        timeByTz,
        doctorId,
        authorId,
        device,
    };
}
